// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1Lt2U","validationTips":"StatementDescriptor_validationTips__3Ikzs"};